import { createFileRoute } from '@tanstack/react-router';
import { ProductsPage } from '@/modules/products/public';
import { RequirePermission, usePermissions } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/produtos/')({
  component: function ProductsRoute() {
    const navigate = Route.useNavigate();
    const { can } = usePermissions();
    return (
      <RequirePermission anyOf={['produtos.ver']}>
        <ProductsPage
          canEdit={can('produtos.editar')}
          onOpen={(productId) => navigate({ to: '/produtos/$productId', params: { productId } })}
          onCreate={() => navigate({ to: '/produtos/novo' })}
        />
      </RequirePermission>
    );
  },
});
